import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { apiClient } from '@/lib/api';
import { STATS_ENDPOINTS } from '@/features/home/api/endpoints';
import type { StatsOverview } from '@/shared/types/api.types';

interface RawOverview {
  totalAfiliadosRegulares?: number;
  totalAfiliadosReg?: number;
  totalAfiliadosPotestativos?: number;
  totalAfiliadosPoternativos?: number;
  totalAfiliadosSCTR?: number;
  totalAfiliadosSctr?: number;
  siniestralidadPromedio?: number;
  promedioSiniestralidad?: number;
}

function normalizeOverview(raw: RawOverview): StatsOverview {
  let siniestralidad = Number(raw.siniestralidadPromedio ?? raw.promedioSiniestralidad ?? 0);

  if (siniestralidad > 0 && siniestralidad <= 1) {
    siniestralidad = siniestralidad * 100;
  }

  return {
    totalAfiliadosRegulares: Number(raw.totalAfiliadosRegulares ?? raw.totalAfiliadosReg ?? 0),
    totalAfiliadosPotestativos: Number(
      raw.totalAfiliadosPotestativos ?? raw.totalAfiliadosPoternativos ?? 0
    ),
    totalAfiliadosSCTR: Number(raw.totalAfiliadosSCTR ?? raw.totalAfiliadosSctr ?? 0),
    siniestralidadPromedio: isFinite(siniestralidad) ? siniestralidad : 0,
  };
}

export function useStatsOverviewQuery(): UseQueryResult<StatsOverview> {
  return useQuery({
    queryKey: ['stats', 'overview'],
    queryFn: async () => {
      const raw = await apiClient<RawOverview>(STATS_ENDPOINTS.OVERVIEW);
      return normalizeOverview(raw);
    },
  });
}

export interface ChartDataset {
  label: string;
  data: number[];
  backgroundColor: string;
}

export interface ChartData {
  labels: string[];
  datasets: ChartDataset[];
}

export function useStatsChartsQuery(): UseQueryResult<ChartData[]> {
  return useQuery({
    queryKey: ['stats', 'charts'],
    queryFn: () => apiClient<ChartData[]>(STATS_ENDPOINTS.CHARTS),
  });
}
